// removed by extract-text-webpack-plugin
module.exports = {"textInformationMargin":"styles__textInformationMargin___1DHsQ","marginSection":"styles__marginSection___3Sb50","container":"styles__container___1-Yny","emptyState":"styles__emptyState___15mzk"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/DataTraffic/components/DetailsList/styles.css
// module id = 2589
// module chunks = 0